import { render, staticRenderFns } from "./LegoSet.vue?vue&type=template&id=0f1a13b2&"
import script from "./LegoSet.vue?vue&type=script&lang=js&"
export * from "./LegoSet.vue?vue&type=script&lang=js&"
import style0 from "./LegoSet.vue?vue&type=style&index=0&id=0f1a13b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports